import { ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';

@Component({
  selector: 'app-detach-truck-and-trailer',
  templateUrl: './detach-truck-and-trailer.component.html',
  styleUrls: ['./detach-truck-and-trailer.component.scss']
})
export class DetachTruckAndTrailerComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  formGroup = new FormGroup({
    swapTrailerNumber: new FormControl(null, [Validators.required])
  });


  constructor(
    private stepperService: TransportAttachDetachStepperService
  ) {
    this.stepperModel = this.stepperService.stepperModel;

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.formGroup.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {

    this.formGroup.patchValue({
      swapTrailerNumber: this.stepperModel.workingData.swapTrailerNumber
    });

    this.formGroup.valueChanges.subscribe(value => {
      this.stepperModel.workingData.swapTrailerNumber = value.swapTrailerNumber;
    });

  }

}
